module.exports = __webpack_public_path__ + "img/map0.e594eab3.jpg";